<template>
    <div class="relative flex items-center justify-center scale-110 lg:scale-125">
        <span class="absolute text-grey-800/60 text-base">
            <span class="font-Inter-Bold text-black">{{ current }}</span>
            <span class="opacity-40">/</span>
            <span class="font-Inter-Regular text-black opacity-40">{{ total }}</span>
        </span>
        <svg width="80" height="80" viewPort="0 0 80 80" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <circle
                :r="radius"
                cx="40"
                cy="40"
                fill="transparent"
                stroke-dasharray="565.486"
                stroke-dashoffset="0"
                stroke="#F2F2F2"
            ></circle>
            <circle
                :r="radius"
                cx="40"
                cy="40"
                fill="transparent"
                stroke="#FFC700"
                stroke-dasharray="188.49555921538757"
                :stroke-dashoffset="dashOffset"
            ></circle>
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        current: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            radius: 30,
        };
    },
    computed: {
        dashOffset() {
            return ((100 - (this.current / this.total) * 100) / 100) * Math.PI * (this.radius * 2);
        },
    },
};
</script>

<style lang="postcss" scoped>
svg {
    transform: rotateZ(-90deg);
}
circle {
    transition: stroke-dashoffset 0.5s cubic-bezier(0.63, 0.06, 0.38, 0.99);
    stroke-width: 8.5px;
}
</style>
